import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { baseURLProd } from '../../api';

const RecordingHook = () => {
    const [marksData,setMarksData] =useState(false)
    const [showModal, setShowModal] = useState(false);
    const [data, setData] = useState([]);
    const [activeIndex, setActiveIndex] = useState(null);
    const [activeSubject, setActiveSubject] = useState(null);
    const [topics, setTopics] = useState([]);

    const toggleModal = () => setShowModal(!showModal);

    const userId =localStorage.getItem('userId');

    useEffect(() => {
        const formData = new FormData();
        formData.append("user_id", userId);

        fetch(`${baseURLProd}recording-section-name`, {
            method: "POST",
            body: formData,
        })
        .then((response) => response.json())
        .then((result) => {
          if (result.status) {
            setData(result.data);
          }
        })
        .catch((error) => console.error("Error fetching data:", error));
    }, []);

    const handleToggle = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
    setActiveSubject(null);
    setTopics([]);
  };

    const handleSubjectClick = async (section_name, subject) => {
        setActiveSubject(subject);
        setTopics([]);
  
        const formData = new FormData();
        formData.append("section_name", section_name);
        formData.append("subject", subject);
        formData.append("user_id", userId);
        try {
        const response = await fetch(`${baseURLProd}get-recording-topic`, {
            method: "POST",
            body: formData,
        })
        const res = await response.json()
        if (res.data && res.status) {
            setTopics(res.data);
          } else {
            console.error("Error fetching topics:", res.status);
          }
        }
         catch (error) {
          console.error("API Error:", error);
        }
    };
    const navigate = useNavigate();

    const handleRecording = () => {
        navigate('/recording')
    }
    const handleSave =()=>{
        setMarksData(true)
    }
    return {
        handleRecording,handleSave,marksData,toggleModal,showModal,data,activeIndex,activeSubject,topics,handleSubjectClick,handleToggle
    }
}

export default RecordingHook
